import Handlebars from 'injectify/runtime';

const ifLength = (arr) => {
    return arr && arr.length && arr.length > 0;
};

/**
 * Checks if array-like has items
 */
Handlebars.registerHelper('if-length', function (arr, options) {
    return ifLength(arr) ? options.fn(this) : options.inverse(this);
});



// WEBPACK FOOTER //
// ./shared/helper/ifLength.js